import api from '@/core/api/client';

export interface Affiliate {
  id: string;
  name: string;
  email: string;
  document?: string | null;
  phone?: string | null;
  commissionPercent?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAffiliateData {
  name: string;
  email: string;
  document?: string;
  phone?: string;
  commissionPercent?: string;
}

export type UpdateAffiliateData = Partial<CreateAffiliateData> & { isActive?: boolean };

export interface AffiliateWithStats extends Affiliate {
  couponCount?: number;
  companiesCount?: number;
}

export const affiliatesService = {
  async list(opts?: { withStats?: boolean }): Promise<Affiliate[] | AffiliateWithStats[]> {
    const params = opts?.withStats ? { withStats: '1' } : undefined;
    const { data } = await api.get<{ success: boolean; data: Affiliate[] | AffiliateWithStats[] }>('/affiliates', { params });
    return data.data;
  },

  async create(body: CreateAffiliateData): Promise<Affiliate> {
    const { data } = await api.post<{ success: boolean; data: Affiliate }>('/affiliates', body);
    return data.data;
  },

  async update(id: string, body: UpdateAffiliateData): Promise<Affiliate> {
    const { data } = await api.put<{ success: boolean; data: Affiliate }>(`/affiliates/${id}`, body);
    if (!data.success) {
      throw new Error('Erro ao atualizar afiliado');
    }
    return data.data;
  },

  async delete(id: string): Promise<void> {
    const { data } = await api.delete<{ success: boolean; message?: string }>(`/affiliates/${id}`);
    if (!data.success) {
      throw new Error(data.message || 'Erro ao excluir afiliado');
    }
  },
};
